import { MILLISECONDS_IN_MINUTE, MILLISECONDS_IN_DAY } from 'constants/DateConstants';

const geoLocationOptions = {
  timeout: MILLISECONDS_IN_MINUTE, // 1 min
  maximumAge: MILLISECONDS_IN_DAY // 24 hours
};

export default geoLocationOptions;
